import React from 'react';
import { useDispatch } from 'react-redux';
import { SystemText } from '@salesperformanceint/e4shared';
import { returnToSelf } from 'actions/user';

// "Return to me" while spoofing, shared by the Prism spoof page and the legacy partner bar. On
// success the user is no longer spoofing, so this unmounts; a failure keeps the spoof session and
// says why, so the user can carry on or try again.
export const ReturnToMe = ({ className = 'btn btn-primary ml10' }) => {
    const dispatch = useDispatch();
    const [working, setWorking] = React.useState(false);
    const [error, setError] = React.useState('');

    const onClick = () => {
        setWorking(true);
        setError('');
        dispatch(
            returnToSelf(undefined, message => {
                setWorking(false);
                setError(message);
            })
        );
    };

    return (
        <>
            <button type="button" className={className} onClick={onClick} disabled={working}>
                {SystemText('Spoof/ReturnToMe')}
            </button>
            {error && (
                <span className="text-danger ml10" role="alert">
                    {error}
                </span>
            )}
        </>
    );
};

export default ReturnToMe;
